import React, { useEffect, useState } from "react";
import TextInput, { ITextInput } from "../input/TextInput";

interface IFilterText extends Omit<ITextInput, "onChange"> {
  defaultValue?: string;
  onChange?: (val: string) => void;
}

function FilterText({
  placeholder,
  label,
  defaultValue,
  onChange,
  ...props
}: IFilterText) {
  //   const [isContain] = useState<boolean>(true); // true: bao gồm; false: không bao gồm
  const [text, setText] = useState<string>(defaultValue || "");

  const updateChange = (value: string) => {
    setText(value);
    onChange?.(value);
  };

  const handleTextChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    updateChange(value);
  };

  useEffect(() => {
    updateChange(defaultValue || "");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultValue]);

  return (
    <TextInput
      multiline={false}
      label={label}
      labelWidth="25%"
      placeholder={placeholder}
      value={text}
      onChange={handleTextChange}
      {...props}
    />
  );
}

export default FilterText;
